import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../api-config';


const CreateDatabase = ({ dbName, setDbName, handleCreateDb }) => (
  <div className="bd-trasparent border-2 text-black p-6 rounded-lg shadow-md mb-6">
    <input
      type="text"
      placeholder="Database Name"
      value={dbName}
      onChange={(e) => setDbName(e.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-md mb-4"
    />
    <button
      onClick={handleCreateDb}
      className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition duration-300"
    >
      Create Database
    </button>
  </div>
);

const DeleteDatabase = ({ databases, dbName, setDbName, handleDeleteDb }) => (
  <div className="bd-trasparent border-2 text-black p-6 rounded-lg shadow-md mb-6">
    <select
      value={dbName}
      onChange={(e) => setDbName(e.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-md mb-4"
    >
      <option value="" disabled>Select Database</option>
      {databases.map((db) => (
        <option key={db} value={db}>
          {db}
        </option>
      ))}
    </select>
    <button
      onClick={handleDeleteDb}
      className="w-full bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition duration-300"
    >
      Delete Database
    </button>
  </div>
);

const Databases = () => {
  const [action, setAction] = useState('create');
  const [dbName, setDbName] = useState('');
  const [databases, setDatabases] = useState([]);
  const [message, setMessage] = useState('');

  const fetchDatabases = async () => {
    try {
      
      const response = await axios.get(`${API_URL}/trading-api/agent/get_db_list`);
      console.log(response.data)
      setDatabases(response.data);
    } catch (error) {
      console.error('Error fetching databases:', error);
    }
  };

  useEffect(() => {
    fetchDatabases();
  }, []);

  const handleCreateDb = async () => {
    try {
      const response = await axios.post(`${API_URL}/trading-api/agent/docs/create_db`, { name: dbName });
      setMessage(`Database created successfully: ${response.data.status}`);
      fetchDatabases();
      window.location.href = '/admin_panel';
    } catch (error) {
      console.error('Error creating database:', error);
      setMessage('Error creating database');
    }
  };

  const handleDeleteDb = async () => {
    try {
      const response = await axios.post(`${API_URL}/trading-api/agent/docs/delete_db`, { name: dbName });
      setMessage(`Database deleted successfully: ${response.data.status}`);
      fetchDatabases();
        window.location.href = '/admin_panel';
    } catch (error) {
      console.error('Error deleting database:', error);
      setMessage('Error deleting database');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10">
      <h1 className="text-2xl font-bold mb-6">Manage Databases</h1>
      <div className="bd-trasparent border-2 text-black p-6 rounded-lg shadow-md mb-6">
        <select
          value={action}
          onChange={(e) => setAction(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md mb-4"
        >
          <option value="create">Create Database</option>
          <option value="delete">Delete Database</option>
        </select>
      </div>
      {action === 'create' ? (
        <CreateDatabase dbName={dbName} setDbName={setDbName} handleCreateDb={handleCreateDb} />
      ) : (
        <DeleteDatabase databases={databases} dbName={dbName} setDbName={setDbName} handleDeleteDb={handleDeleteDb} />
      )}
      {message && <p className="mt-4 text-center text-gray-700">{message}</p>}
      
    </div>
  );
};

export default Databases;
